import { ButtonClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiButton: Record<ButtonClassKey, CSSProperties> = {
  root: {
    boxShadow: 'none',
    padding: 5,
    position: 'relative',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: 'white',
    borderRadius: 50,
    width: '100%',
  },
  colorInherit: {},
  contained: {
    color: 'white',
    '& + .MuiCircularProgress-root': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.08))',
    boxShadow: 'none',
  },
  containedPrimary: {
    color: 'white',
    '& + .MuiCircularProgress-root': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    '&.Mui-disabled': {
      color: 'white',
      backgroundColor: '#CDDED9',
    },
    '&:hover': {
      backgroundColor: '#419484',
    },
  },
  containedSecondary: {},
  containedSizeLarge: {},
  containedSizeSmall: {
    padding: '10px 0px',
  },
  disableElevation: {},
  disabled: {},
  endIcon: {},
  focusVisible: {},
  fullWidth: {},
  iconSizeLarge: {},
  iconSizeMedium: {},
  iconSizeSmall: {},
  label: {
    textTransform: 'none',
    fontFamily: 'CircularXX-Book, sans-serif',
    fontSize: 18,
    fontWeight: 400,
  },
  outlined: {},
  outlinedPrimary: {},
  outlinedSecondary: {},
  outlinedSizeLarge: {},
  outlinedSizeSmall: {},
  sizeLarge: {},
  sizeSmall: {},
  startIcon: {},
  text: {},
  textPrimary: {},
  textSecondary: {},
  textSizeLarge: {},
  textSizeSmall: {},
};
